import _ from 'lodash';
import React, {Component, PropTypes} from 'react';
import { readComponentInstanceResourceList } from 'lib/frankly';
import ComponentLoader from '../../../shared/utils/ComponentLoader';

class AssociatedContent extends Component {
  static propTypes = {
    resources: PropTypes.object,
    FRN_rawResponses: PropTypes.array,
    displayComponentId: PropTypes.string.isRequired,
    displayComponentProps: PropTypes.object,
    filter: PropTypes.object,
    dataPath: PropTypes.string,
    data: PropTypes.shape({
      type: PropTypes.oneOf(['url', 'object']),
      filter: PropTypes.object
    })
  }

  static defaultProps = {
    dataPath: '[0].data.features',
    data: {
      type: 'object'
    }
  }

  state = {
    ComponentClass: null,
    rawResponses: this.props.FRN_rawResponses,
    gotImplicitData: false,
  }

  ssr_state = {
    ComponentClass: null,
    rawResponses: []
  }

  componentWillMount() {
    const {
      resources = {},
      FRN_resourceEndpoints = [],
      FRN_rawResponses: rawResponses = [],
      displayComponentId,
      data: {
        type,
        filter = {}
      } = {}
    } = this.props;

    if (typeof window !== 'undefined') { // CSR
        ComponentLoader.importReactComponent(displayComponentId).then(ComponentClass =>
            this.setState({ ComponentClass })
            ).catch(error => {
                throw new Error(error);
            });

    } else { //SSR 
        this.ssr_state.ComponentClass = ComponentLoader._modules[displayComponentId] ? ComponentLoader._modules[displayComponentId] : null;
    }

    if (typeof window !== 'undefined') { // CSR
        if (rawResponses.length > 0) {
            if (type === 'url') {
                this.getImplicitData(rawResponses);
            } else {
                this.setState({ rawResponses });
            }
        }

    } else { // SSR
        this.ssr_state.rawResponses = this.getRawResponses(FRN_resourceEndpoints);

        if (type === 'url') {
            const url = this.getImplicitUrl(this.ssr_state.rawResponses);

            if (url && resources[url + '?clienttype=container.json']) {
                this.ssr_state.rawResponses = [resources[url + '?clienttype=container.json']];
            }
        }
    }
  }

  componentWillReceiveProps(newProps) {
    const {
      FRN_rawResponses: rawResponses,
      data: {
        type
      } = {}
    } = newProps;

    if (this.props.FRN_rawResponses.length === 0 && rawResponses.length > 0) {
      if (type === 'url') {
        this.getImplicitData(rawResponses);
      } else {
        this.setState({ rawResponses });
      }
    }
  }

  getRawResponses = (resourceEndpoints = []) => {  // SSR
    const {resources = {}} = this.props;
    let rawResponses = [];

    if (_.size(resourceEndpoints) > 0) {
      rawResponses = resourceEndpoints
          .map(resource => {
            let pat = new RegExp("\/[\u0024][\u007B]id[\u007D]\/", "i");

            if (pat.test(resource.url)) {
                const url = resource.url.replace('${id}', this.props.params.id);
                return resources[url] ? resources[url] : null;
            }
            return resources[resource.url] ? resources[resource.url] : null;
          })
          .filter(resource => resource !== null);
    }

    return rawResponses;
  }

  getImplicitUrl = (FRN_rawResponses = []) => {
    const filter = _.cloneDeep(_.get(this.props, 'data.filter', {}));
    const items = _.get(FRN_rawResponses[0], 'data.features', []);

    const {
      index = 0
    } = filter;

    _.unset(filter, 'index');

    const filteredList = _.filter(items, filter);
    const url = _.get(filteredList[index], 'link', '');

    return url;
  }

  getImplicitData = (FRN_rawResponses) => {
    const url = this.getImplicitUrl(FRN_rawResponses);

    readComponentInstanceResourceList(this, { propPath: 'data', vars: { url } }).then(rawResponses => {
      this.setState({ rawResponses, gotImplicitData: true });
    }).catch(error => {
      throw new Error(error);
    });
  }

  render() {
    const {
      displayComponentProps = {},
      filter = {},
      dataPath,
      data: {
        type
      }
    } = this.props;

    if (typeof window !== 'undefined' && type === 'url' && !this.state.gotImplicitData) { // CSR
      return null;
    }

    const {
      ComponentClass,
      rawResponses
    } = typeof window !== 'undefined' ? this.state : this.ssr_state;

    if (!ComponentClass) {
      return null;
    }

    const [
      {
        data: {
          features: items = []
        } = {}
      } = {}
    ] = rawResponses;

    if (!items.length) {
      return null;
    }

    const { index } = filter;

    const stories = items[index] ? [items[index]] : _.filter(items, filter);

    let newRawResponses = JSON.parse(JSON.stringify(rawResponses)); // deep copy

    _.set(newRawResponses, dataPath, stories);

    return (
      <div className="AssociatedContent">
        { ComponentClass && <ComponentClass FRN_rawResponses={newRawResponses} {...displayComponentProps} /> }
      </div>
    );
  }
}

export default AssociatedContent;



// WEBPACK FOOTER //
// ./app/components/news/AssociatedContent.js